<template>
  <div>
    <create-password v-if="mode === 'resetPassword'" :code="code" />
    <verify-email v-else-if="mode === 'verifyEmail'" :code="code" />
    <resend-verification-email v-else-if="mode === 'resendVerificationEmail'" />
  </div>
</template>

<script>
import CreatePassword from './CreatePassword.vue';
import VerifyEmail from './VerifyEmail.vue'
import ResendVerificationEmail from './ResendVerificationEmail.vue'

export default {
    components: {
        CreatePassword,
        VerifyEmail,
        ResendVerificationEmail
    },
    computed: {
        mode() {
            return this.$route.query.mode
        },
        code() {
            return this.$route.query.oobCode
        }
    }
}
</script>